import { Injectable } from '@angular/core';
import { ActiveState, EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { CursorPaging, Department } from '@etop/models';
import { DepartmentAPI } from '@etop/api';

export interface StateDepartment extends EntityState<Department, string>, ActiveState {
  ui: {
    filter: DepartmentAPI.GetDepartmentsFilter;
    paging: CursorPaging;
    currentPage: Number;
  };
}

const initialState = {
  ui: {
    filter: {},
    paging: null,
    currentPage: 1,
  },
};

@Injectable({
  providedIn: 'root'
})
@StoreConfig({ name: 'shopDepartment', resettable: true })
export class DepartmentStore extends EntityStore<StateDepartment> {
  constructor() {
    super(initialState);
  }
}
